/**
 * * Модель настроек видимости списка задач
 */
export default class GetTaskListRequestVisibleSettings  {
	/**
	 * * Видимость создателя
	 */
	VisibleOwner: boolean = false;
	/**
	 * * Видимость исполнителя
	 */
	VisiblePerformers: boolean = false;
	/**
	 * * Видимость наблюдателя
	 */
	VisibleObservers: boolean = false;
	/**
	 * * Видимость статуса
	 */
	VisibleStatus: boolean = false;
	/**
	 * * Видимость приоритета
	 */
	VisiblePriority: boolean = false;
	/**
	 * * Видимость типа
	 */
	VisibleType: boolean = false;
	/**
	 * * Видимость файлов
	 */
	VisibleFiles: boolean = false;
	/**
	 * * Видимость тегов
	 */
	VisibleTags: boolean = false;
	/**
	 * * Видимость даты начала
	 */
	VisibleDateCreate: boolean = false;
	/**
	 * * Видимость дедлайна
	 */
	VisibleDateEnd: boolean = false;
	/**
	 * * Отображать подзадачи
	 */
	VisibleSubtask: boolean = false;
	constructor(obj?: Partial<GetTaskListRequestVisibleSettings>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
